import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card } from 'antd'
import './style.css'
// import { width } from 'window-size';

class CardObj extends Component {
  render() {
    return (
      <div className="header-card">
        <Card className="content-card">
          <Link to={`/${this.props.event.slug}`} >

            <img
              className="head-image"
              src={this.props.event.logoImage}
              alt={this.props.event.logoImage}
            />

          </Link>

          {this.props.children}

        </Card>
      </div>

    )
  }
}

export default CardObj



// WEBPACK FOOTER //
// ./src/Home/Component/CardObj.js